<template>
  <div>
    <v-layout>
      <v-dialog
        v-model="show"
        :fullscreen="$vuetify.breakpoint.smAndDown"
        persistent
        max-width="600px"
      >
        <v-toolbar color="blue darken-2" dark>
          <v-btn icon dark @click.stop="show=false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Reports</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card>
          <v-list two-line subheader>
            <v-subheader inset>Vendors</v-subheader>

            <v-list-tile
              v-for="item in items"
              :key="item.title"
              avatar
            >
              <v-list-tile-avatar @click="report(item.action)">
                <v-icon :class="[item.iconClass]">{{ item.icon }}</v-icon>
              </v-list-tile-avatar>

              <v-list-tile-content @click="report(item.action)">
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                <v-list-tile-sub-title>{{ item.subtitle }}</v-list-tile-sub-title>
              </v-list-tile-content>

              <v-list-tile-action>
                <v-progress-circular
                  v-show="loading && item.action === 'checkIn'"
                  indeterminate
                  color="primary"
                ></v-progress-circular>
                <v-btn v-show="checkinDownload && item.action === 'checkIn'" fab dark small color="primary" :href="fileName" target="_blank">
                  <v-icon dark>mdi-download</v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>

            <v-divider inset></v-divider>

            <v-subheader inset>Accounting</v-subheader>

            <v-list-tile
              v-for="item in items2"
              :key="item.title"
              avatar
              @click="report(item.action)"
            >
              <v-list-tile-avatar>
                <v-icon :class="[item.iconClass]">{{ item.icon }}</v-icon>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                <v-list-tile-sub-title>{{ item.subtitle }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-card>
      </v-dialog>

      <v-snackbar
        v-model="snackbar.show"
        :color="snackbar.color"
        :multi-line=true
        :timeout="6000"
      >
        {{ snackbar.message }}
        <v-btn
          dark
          flat
          @click="snackbar.show = false"
        >
          Close
        </v-btn>
      </v-snackbar>
    </v-layout>
  </div>
</template>

<script>
import Api from '@/services/Api'
import XLSX from 'xlsx'
import moment from 'moment'

export default {
  props: ['visible', 'currentYear'],

  data () {
    return {
      rows: [],
      items: [
        { icon: 'mdi-account-group', iconClass: 'grey lighten-1 white--text', title: 'Vendor Report', subtitle: 'Report of all Vendors', action: 'vendor' },
        { icon: 'mdi-hoop-house', iconClass: 'grey lighten-1 white--text', title: 'Booth Report', subtitle: 'Report of all Booths', action: 'booth' },
        { icon: 'mdi-file-check-outline', iconClass: 'grey lighten-1 white--text', title: 'Check-In Forms', subtitle: 'Check-In Sheets', action: 'checkIn' }
      ],
      items2: [
        { icon: 'mdi-receipt-text-outline', iconClass: 'blue white--text', title: 'Invoice Report', subtitle: 'Report of all Invoices', action: 'invoice' },
        { icon: 'mdi-cash', iconClass: 'amber white--text', title: 'Payment Report', subtitle: 'Report of all payments', action: 'payment' }
      ],
      loading: false,
      checkinDownload: false,
      fileName: process.env.API_URL + '/attachments/checkin.pdf',
      snackbar: {
        show: false,
        color: '',
        message: ''
      }
    }
  },

  created () {
  },

  computed: {
    show: {
      get () {
        return this.visible
      },
      set (value) {
        if (!value) {
          this.$emit('close', 'the test')
        }
      }
    }
  },

  methods: {
    report (report) {
      this.rows = []

      if (report === 'deposit') {
        this.getPayments(9, 'Venddor Deposit Report')
      } else if (report === 'tax') {
        this.getPayments(23, 'Vendor Tax Report')
      } else if (report === 'payment') {
        this.getPayments(0, 'Vendor Payment Report')
      } else if (report === 'invoice') {
        this.getInvoices(0, 'Vendor Invoice Report')
      } else if (report === 'accounting') {
        this.getPayments(0, 'Vendor Payment Report')
      } else if (report === 'booth') {
        this.getBooths('Vendor Booth Report')
      } else if (report === 'checkIn') {
        this.checkInForm()
      } else if (report === 'vendor') {
        this.reportVendors('Vendor Report')
      }
    },

    async getBooths (title) {
      try {
        const response = await Api().get('booths/' + this.currentYear)

        const booths = response.data

        for (let i in booths) {
          let name = ''
          let address = ''
          let city = ''
          let state = ''
          let zip = ''
          let rep = ''
          let email = ''
          let phone = ''
          let mobile = ''

          if (booths[i].VendorCompany) {
            let vendor = booths[i].VendorCompany
            name = vendor.name
            address = vendor.address
            city = vendor.city
            state = vendor.state
            zip = vendor.zip

            if (vendor.VendorContacts[0]) {
              let user = vendor.VendorContacts[0]
              rep = user.fullName
              email = user.email
              phone = user.phone
              mobile = user.mobile
            }
          }

          booths[i].name = name
          booths[i].address = address
          booths[i].city = city
          booths[i].state = state
          booths[i].zip = zip
          booths[i].contact = rep
          booths[i].email = email
          booths[i].phone = phone
          booths[i].mobile = mobile
        }

        console.log(this.currentYear, booths)

        let printVendors = booths.map(a => ({
          'Booth Number': a.boothNumber,
          'Company': a.name,
          'Address': a.address,
          'City': a.city,
          'State': a.state,
          'Zip': a.zip,
          'Contact': a.contact,
          'Email': a.email,
          'Phone': a.phone,
          'Mobile': a.mobile,
          'Size': a.size,
          'Area': a.area,
          'Location': a.location
        }))

        let membersWS = XLSX.utils.json_to_sheet(printVendors)

        let wb = XLSX.utils.book_new()

        if (!wb.Props) { wb.Props = {} }
        wb.Props.Title = title

        XLSX.utils.book_append_sheet(wb, membersWS, title)

        XLSX.writeFile(wb, title + '.xlsx')
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async getVendors (title) {
      try {
        await Api().get('vendors/' + this.currentYear)
          .then(res => {
            const vendorList = res.data
            console.log('NEW', vendorList)

            let row = {}
            for (let i in vendorList) {
              row.name = vendorList[i].name
              row.address = vendorList[i].address
              row.city = vendorList[i].city
              row.state = vendorList[i].state
              row.zip = vendorList[i].zip
              row.new = vendorList[i].new
              row.returning = vendorList[i].returning
              row.createDate = moment(vendorList[i].createdAt).format('MM/DD/YYYY - hh:mm A')
              row.returning = vendorList[i].returning
              row.fullName = vendorList[i].VendorContacts[0].fullName
              row.email = vendorList[i].VendorContacts[0].email
              row.phone = vendorList[i].VendorContacts[0].phone
              row.mobile = vendorList[i].VendorContacts[0].mobile
              row.terms = vendorList[i].VendorDetails[0].terms
              row.insurance = vendorList[i].VendorDetails[0].insurance
              row.wifiUser = vendorList[i].VendorDetails[0].wifiUser
              row.wifiPassword = vendorList[i].VendorDetails[0].wifiPassword
              row.businessLicense = vendorList[i].VendorDetails[0].businessLicense
              row.parkingRequired = vendorList[i].VendorDetails[0].parkingRequired
              row.parkingIssued = vendorList[i].VendorDetails[0].parkingIssued
              row.badgesRequired = vendorList[i].VendorDetails[0].badgesReturned
              row.badgesIssued = vendorList[i].VendorDetails[0].badgesIssued

              if (vendorList[i].VendorDetails[0].checkIn === 'Yes') {
                vendorList[i].VendorDetails[0].checkIn = 'Saturday'
              } else if (vendorList[i].VendorDetails[0].checkIn === 'No') {
                vendorList[i].VendorDetails[0].checkIn = 'Standard'
              }

              row.checkIn = vendorList[i].VendorDetails[0].checkIn

              let rep = ''
              if (vendorList[i].VendorDetails[0].User) {
                let user = vendorList[i].VendorDetails[0].User
                rep = user.fullName
              }

              let rating = ''
              if (vendorList[i].VendorDetails[0].rating) {
                rating = '-' + vendorList[i].VendorDetails[0].rating
              }

              row.rep = rep
              row.booths = 'Y' + vendorList[i].VendorDetails[0].year.toString().slice(-2) + rating

              this.rows.push(row)
              row = {}
            }

            // this.reportVendors(title)
          })
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async checkInForm () {
      try {
        this.loading = true
        // const response = await Api().get('get_checkin/' + this.currentYear)
        await Api().post('get_checkin/' + this.currentYear).then((response) => {
          window.open(process.env.API_URL + '/attachments/checkin.pdf', '_blank')

          this.loading = false
          this.checkinDownload = true
        })
      } catch (error) {
        this.error = error.response.data.error
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async reportVendors (title) {
      try {
        const response = await Api().get('vendors_reports/' + this.currentYear)

        const vendorList = response.data
        console.log(vendorList)

        let row = {}

        for (let i in vendorList) {
          row.name = vendorList[i].name
          row.address = vendorList[i].address
          row.city = vendorList[i].city
          row.state = vendorList[i].state
          row.zip = vendorList[i].zip
          row.new = vendorList[i].new
          row.returning = vendorList[i].returning
          row.createDate = moment(vendorList[i].createdAt).format('MM/DD/YYYY - hh:mm A')
          row.fullName = vendorList[i].VendorContacts[0].fullName
          row.email = vendorList[i].VendorContacts[0].email
          row.phone = vendorList[i].VendorContacts[0].phone
          row.mobile = vendorList[i].VendorContacts[0].mobile
          row.terms = vendorList[i].VendorDetails[0].terms
          row.insurance = vendorList[i].VendorDetails[0].insurance
          row.wifiUser = vendorList[i].VendorDetails[0].wifiUser
          row.wifiPassword = vendorList[i].VendorDetails[0].wifiPassword
          row.businessLicense = vendorList[i].VendorDetails[0].businessLicense
          row.parkingRequired = vendorList[i].VendorDetails[0].parkingRequired
          row.parkingIssued = vendorList[i].VendorDetails[0].parkingIssued
          row.badgesRequired = vendorList[i].VendorDetails[0].badgesReturned
          row.badgesIssued = vendorList[i].VendorDetails[0].badgesIssued

          if (vendorList[i].returning === 'Yes') {
            row.returning = 'Rodeo'
          } else if (vendorList[i].returning === 'Both') {
            row.returning = 'Rodeo and Concert'
          }

          if (vendorList[i].VendorDetails[0].checkIn === 'Yes') {
            vendorList[i].VendorDetails[0].checkIn = 'Saturday'
          } else if (vendorList[i].VendorDetails[0].checkIn === 'No') {
            vendorList[i].VendorDetails[0].checkIn = 'Standard'
          }

          row.checkIn = vendorList[i].VendorDetails[0].checkIn

          let rep = ''
          if (vendorList[i].VendorDetails[0].User) {
            let user = vendorList[i].VendorDetails[0].User
            rep = user.fullName
          }

          let booths = ''

          for (let j in vendorList[i].VendorBooths) {
            booths = booths + vendorList[i].VendorBooths[j].boothNumber + ' '
          }

          row.rep = rep
          row.booths = booths
          this.rows.push(row)
          row = {}
        }

        let printVendors = this.rows.map(a => ({
          'Name': a.name,
          'Address': a.address,
          'City': a.city,
          'State': a.state,
          'Zip': a.zip,
          'New': a.new,
          'Returning': a.returning,
          'Create Date': a.createDate,
          'Booth(s)': a.booths,
          'Contact': a.fullName,
          'Email': a.email,
          'Phone': a.phone,
          'Mobile': a.mobile,
          'Terms': a.terms,
          'Insurance': a.insurance,
          'Business License': a.businessLicense,
          'Parking Rrequired': a.parkingRequired,
          'Parking Issued': a.parkingIssued,
          'Badges Rrequired': a.badgesRequired,
          'Badges Issued': a.badgesIssued,
          'Typr': a.checkIn,
          'Rep': a.rep
        }))

        let membersWS = XLSX.utils.json_to_sheet(printVendors)

        let wb = XLSX.utils.book_new()

        if (!wb.Props) { wb.Props = {} }
        wb.Props.Title = title

        XLSX.utils.book_append_sheet(wb, membersWS, title)

        XLSX.writeFile(wb, title + '.xlsx')
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async getInvoices (payType, title) {
      try {
        const response = await Api().get('vendors_invoices/' + this.currentYear)

        const acct = response.data
        console.log('invoices', acct)

        let row = {}
        const rows = []

        for (let i in acct) {
          let booths = ''
          for (let k in acct[i].VendorBooths) {
            booths = booths + acct[i].VendorBooths[k].boothNumber + ' '
          }

          for (let j in acct[i].VendorAccountings) {
            let description = ''
            let comma = ''
            let total = 0

            for (let k in acct[i].VendorAccountings[j].VendorAccountingDetails) {
              let amount = Number(acct[i].VendorAccountings[j].VendorAccountingDetails[k].quantity) * Number(acct[i].VendorAccountings[j].VendorAccountingDetails[k].price)
              console.log(amount)
              description = description + comma + acct[i].VendorAccountings[j].VendorAccountingDetails[k].description
              comma = ', '
              total = total + amount
            }

            row.name = acct[i].name
            row.address = acct[i].address
            row.city = acct[i].city
            row.state = acct[i].state
            row.zip = acct[i].zip
            row.fullName = acct[i].VendorContacts[0].fullName
            row.email = acct[i].VendorContacts[0].email
            row.phone = acct[i].VendorContacts[0].phone
            row.mobile = acct[i].VendorContacts[0].mobile
            row.booths = booths
            row.ptype = 'Invoice'
            row.invNo = acct[i].VendorAccountings[j].id
            row.notes = acct[i].VendorAccountings[j].notes
            row.description = description
            row.amount = total

            rows.push(row)
            row = {}
          }

          row = {}
        }

        let printPayments = rows.map(a => ({
          'Name': a.name,
          'Address': a.address,
          'City': a.city,
          'State': a.state,
          'Zip': a.zip,
          'Booth(s)': a.booths,
          'Contact': a.fullName,
          'Email': a.email,
          'Phone': a.phone,
          'Mobile': a.mobile,
          'Event': a.ptype,
          'Invoice No': a.invNo,
          'Notes': a.notes,
          'Description': a.description,
          'Amount': a.amount
        }))

        let membersWS = XLSX.utils.json_to_sheet(printPayments)

        let wb = XLSX.utils.book_new()

        if (!wb.Props) { wb.Props = {} }
        wb.Props.Title = title

        XLSX.utils.book_append_sheet(wb, membersWS, title)

        XLSX.writeFile(wb, title + '.xlsx')
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async getPayments (payType, title) {
      try {
        const response = await Api().get('vendors_payments/' + this.currentYear)

        const acct = response.data

        let row = {}
        const rows = []

        for (let i in acct) {
          let booths = ''
          for (let k in acct[i].VendorBooths) {
            booths = booths + acct[i].VendorBooths[k].boothNumber + ' '
          }

          for (let j in acct[i].VendorAccountings) {
            row.name = acct[i].name
            row.address = acct[i].address
            row.city = acct[i].city
            row.state = acct[i].state
            row.zip = acct[i].zip
            row.fullName = acct[i].VendorContacts[0].fullName
            row.email = acct[i].VendorContacts[0].email
            row.phone = acct[i].VendorContacts[0].phone
            row.mobile = acct[i].VendorContacts[0].mobile
            row.booths = booths
            row.ptype = 'Payment'
            row.payType = acct[i].VendorAccountings[j].payType
            row.cardName = acct[i].VendorAccountings[j].cardName
            row.cardNumber = acct[i].VendorAccountings[j].cardNumber
            row.expire = acct[i].VendorAccountings[j].expire
            row.cardApproval = acct[i].VendorAccountings[j].cardApproval
            row.amount = Number(acct[i].VendorAccountings[j].amount)
            row.notes = acct[i].VendorAccountings[j].notes
            row.taxAmount = ''
            row.serviceFee = ''
            row.cashAmount = ''
            row.checkAmount = ''

            if (acct[i].VendorAccountings[j].paymentType === 9) {
              row.ptype = 'Deposit'

              if (acct[i].VendorAccountings[j].payType === 'Credit Card') {
                row.taxAmount = row.amount
              } else if (acct[i].VendorAccountings[j].payType === 'Cash') {
                row.cashAmount = row.amount
              } else {
                row.checkAmount = row.amount
              }
            } else if (acct[i].VendorAccountings[j].paymentType === 23) {
              row.ptype = 'Sales Tax'

              if (acct[i].VendorAccountings[j].payType === 'Credit Card') {
                let taxAmount = Math.round((Number(row.amount) / 1.04 + Number.EPSILON) * 100) / 100
                let serviceFee = row.amount - taxAmount
                row.serviceFee = Math.round(serviceFee * 100) / 100
                row.taxAmount = Math.round(taxAmount * 100) / 100
              } else if (acct[i].VendorAccountings[j].payType === 'Cash') {
                row.cashAmount = row.amount
              } else {
                row.checkAmount = row.amount
              }
            }

            if (payType > 0) {
              if (acct[i].VendorAccountings[j].paymentType === payType) {
                acct[i].acct = acct[i].VendorAccountings[j]

                rows.push(row)
                row = {}
              }
            } else {
              rows.push(row)
              row = {}
            }
          }

          row = {}
        }
        console.log(rows)
        let printPayments = ''

        if (payType === 23) {
          printPayments = rows.map(a => ({
            'Name': a.name,
            'Address': a.address,
            'City': a.city,
            'State': a.state,
            'Zip': a.zip,
            'Booth(s)': a.booths,
            'Contact': a.fullName,
            'Email': a.email,
            'Phone': a.phone,
            'Mobile': a.mobile,
            'Event': a.ptype,
            'Pay Type': a.payType,
            'Card Name': a.cardName,
            'Number': a.cardNumber,
            'Expire': a.expire,
            'Approval': a.cardApproval,
            'Service Fee': a.serviceFee,
            'Credit Amount': a.taxAmount,
            'Check Amount': a.checkAmount,
            'Cash Amount': a.cashAmount,
            'Total': a.amount,
            'Notes': a.notes
          }))
        } else {
          printPayments = rows.map(a => ({
            'Name': a.name,
            'Address': a.address,
            'City': a.city,
            'State': a.state,
            'Zip': a.zip,
            'Booth(s)': a.booths,
            'Contact': a.fullName,
            'Email': a.email,
            'Phone': a.phone,
            'Mobile': a.mobile,
            'Event': a.ptype,
            'Pay Type': a.payType,
            'Card Name': a.cardName,
            'Number': a.cardNumber,
            'Expire': a.expire,
            'Approval': a.cardApproval,
            'Credit Amount': a.taxAmount,
            'Check Amount': a.checkAmount,
            'Cash Amount': a.cashAmount,
            'Total': a.amount,
            'Notes': a.notes
          }))
        }

        let membersWS = XLSX.utils.json_to_sheet(printPayments)

        let wb = XLSX.utils.book_new()

        if (!wb.Props) { wb.Props = {} }
        wb.Props.Title = title

        XLSX.utils.book_append_sheet(wb, membersWS, title)

        XLSX.writeFile(wb, title + '.xlsx')
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/vendor/Reports.vue